import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The text sizes of the charter (`--text-*` of the design system package). Without them
 * `tailwind-merge` takes `text-caption` for a text colour and drops it when a colour follows
 * (`text-caption text-gray-700` lost its size).
 */
const TAILLES_CHARTE = [
  'display',
  'h1',
  'h2',
  'h3',
  'h4',
  'body-lg',
  'body',
  'small',
  'caption',
  'micro',
  'badge',
  'modal-title',
];

const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: TAILLES_CHARTE }] } },
});

/**
 * Merge Tailwind class names, deduplicating conflicts.
 * Standard shadcn/ui utility - use on every component that accepts a `className` prop.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
